<template>
  <v-container
    id="inner-filter"
    class="filter-field"
    fluid
    style="padding: 15px 52px;"
  >
    &nbsp;
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  watch: {
    '$route.path' (newPath, old) {
      this.initFilter()
    }
  },
  mounted: function () {
    this.initFilter()
  },
  methods: {
    initFilter () {
      this.updatePayload()
    },
    updatePayload () {
      const payload = { 'media': true }

      this.$emit('updatePayload', payload)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/app/contents/MediaContentFilter.vue